import {useState, useEffect} from "react";
import axios from "axios";
import "./Orders.scss";
import {useNavigate} from "react-router-dom";
import CommaSeparator from "../../../../Utils/CommaSeparator";
import {prefixUrl} from "../../../../Utils/utilsData";
import {toast} from "react-toastify";
import Loader from "../../../Loader/Loader";

const Orders = () => {
  const navigateTo = useNavigate();
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [ordersDataFromBackend, setOrdersDataFromBackend] = useState([]);
  const [isLoad, setIsLoad] = useState(false);

  useEffect(() => {
    axios.get(`${prefixUrl()}/user/orders.php`).then((response) => {
      if (response.data.status) {
        setOrdersDataFromBackend(response.data.output);
        setIsLoad(true)
      } else {
        toast.error("خطا در بر قراری ارتباط")
      }
    });
  }, []);

  const moveToDetailshandle = (id) => {
    let orderDetails = ordersDataFromBackend.filter(
      (item) => item.orderId === id
    );
    // const orderDetails = ordersDataFromBackend.foreach((item)=>item.);
    navigateTo("/OrdersDetails", {state: {orderDetails}});
  };

  return (
    <div className="orders">
      {isLoad ?
        <>
          {ordersDataFromBackend.length === 0 ? (
            <>سفارشی ثبت نکرده اید</>
          ) : (
            ordersDataFromBackend.map((orderData) => (
              <div key={orderData.id}>
                <div className="OrderCode">
                  <span>کد سفارش :</span>
                  <span className="code">{orderData.orderId}</span>
                </div>
                <div className="cardOrders">
                  <div className="imageleft">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      onClick={() => moveToDetailshandle(orderData.orderId)}
                    >
                      <path
                        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                        fill="#EE6900"
                      />
                      <path
                        d="M13.2599 16.2802C13.0699 16.2802 12.8799 16.2102 12.7299 16.0602L9.19992 12.5302C8.90992 12.2402 8.90992 11.7602 9.19992 11.4702L12.7299 7.94016C13.0199 7.65016 13.4999 7.65016 13.7899 7.94016C14.0799 8.23016 14.0799 8.71016 13.7899 9.00016L10.7899 12.0002L13.7899 15.0002C14.0799 15.2902 14.0799 15.7702 13.7899 16.0602C13.6499 16.2102 13.4599 16.2802 13.2599 16.2802Z"
                        fill="#EE6900"
                      />
                    </svg>
                  </div>
                  <div className="rowPayment">
                    <div className="imageTik">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
                          fill="#EE6900"
                        />
                      </svg>
                    </div>
                    <div className="spanPayment">
                      <span>{orderData.status} </span>
                    </div>
                    <div className="date">
                      <div className="imageCircle">
                        <svg
                          width="4"
                          height="4"
                          viewBox="0 0 4 4"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="2" cy="2" r="2" fill="#DADADA"/>
                        </svg>
                      </div>
                      <span>تاریخ</span>
                      <div className="backendDate">
                    <span>
                      {orderData.backendDate} ، {orderData.date}{" "}
                    </span>
                      </div>
                    </div>
                    <div className="Amount">
                      <div className="imageCircle">
                        <svg
                          width="4"
                          height="4"
                          viewBox="0 0 4 4"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="2" cy="2" r="2" fill="#DADADA"/>
                        </svg>
                      </div>
                      <span>مبلغ</span>
                      <div className="backendAmount">
                        <span>{CommaSeparator(orderData.totalAmount)}ریال</span>
                      </div>
                    </div>
                    {/* <div className="Discount">
                  <div className="imageCircle">
                    <svg
                      width="4"
                      height="4"
                      viewBox="0 0 4 4"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="2" cy="2" r="2" fill="#DADADA" />
                    </svg>
                  </div>
                  <span>تخفیف</span>
                  <div className="backendDiscount">
                    <span>
                      {CommaSeparator(orderData.backendDiscount)} ریال
                    </span>
                  </div>
                </div> */}
                    {/* <div className="tax">
                  <div className="imageCircle">
                    <svg
                      width="4"
                      height="4"
                      viewBox="0 0 4 4"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="2" cy="2" r="2" fill="#DADADA" />
                    </svg>
                  </div>
                  <span>مالیات</span>
                  <div className="backendtax">
                    <span>{CommaSeparator(orderData.backendtax)} ریال</span>
                  </div>
                </div> */}
                    {/* <div className="PackagingAndShipping">
                  <div className="imageCircle">
                    <svg
                      width="4"
                      height="4"
                      viewBox="0 0 4 4"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="2" cy="2" r="2" fill="#DADADA" />
                    </svg>
                  </div>
                  <span>بسته بندی و ارسال</span>
                  <div className="backendPackagingAndShipping">
                    <span>
                      {CommaSeparator(orderData.backendPackagingAndShipping)}{" "}
                      ریال
                    </span>
                  </div>
                </div> */}
                  </div>
                  <div className="rowCardOrder">
                    {orderData.items.map((item, itemIndex) => (
                      <div className="cardInOrderCard" key={itemIndex}>
                        <div className="imageCommodity">
                          <img src={item.image} alt=""/>
                        </div>
                        <div className="columnNameAndNum">
                          <span className="Titel">{item.productName}</span>
                          <span className="Number"> {item.count}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))
          )}
        </>
        : <Loader/>}
    </div>
  );
};

export default Orders;
